import { defineStore } from 'pinia'

export const useAlertsStore = defineStore('alerts', {
  state: () => ({
    initialized: false,
    count: 0
  }),
  actions: {
    async init() {
      if (this.initialized) {
        return
      }
      const { data: { data } } = await this.$api.notifications.alarms.count()
      this.initialized = true
      this.count = data.count
    },
    increment() {
      if (!this.initialized) {
        return
      }
      this.count++
    },
    decrement() {
      if (!this.initialized) {
        return
      }
      this.count--
    },
    subtract(subtractCount) {
      if (!this.initialized) {
        return
      }
      this.count = this.count - subtractCount
    }
  }
})
